module.exports = _.omit;